import {ContactorTypeDict, WeChatOrganizationTypeDict} from "../../../config/MerchantType";
import React, {useEffect, useState} from "react";
import {Button, Cascader, Checkbox, DatePicker, Input, message, Radio, Select, Upload} from "antd";
import Tips from "./tips";
import Audit from "./audit";
import locale from "antd/es/date-picker/locale/zh_CN";
import {UploadOutlined} from "@ant-design/icons";
import {subMerchantMaterialInfoSelector, setSubMerchantMaterialInfo} from "../../../store/merchant"
import {useDispatch, useSelector} from "react-redux";
import Regions from "../../../utils/region.json";
import qs from "../../../utils/qs";
import StepController from "./stepController";
import {ID_CARD_VALID_TIME_SHORT, ID_CARD_VALID_TIME_FOREVER} from '../../../config/IdCardValidTimeType';
import moment from "moment";
import config from "../../../config/upload";
import KeysMap from '../../../config/subMchMaterialKeyMap';
import {TO_PERSONAL_ACCOUNT, TO_COMPANY_ACCOUNT, selectedBankId, OTHER_BANK_ID} from "../../../config/bankAccountType";
import _ from "lodash";
import EventDispatcher from "../../../events";
import {SubmitSubMchMaterialEvent} from "../../../events/SubmitSubMchMaterialEvent";

const photoUploadProps = ({uploaded, error}) => {
    return {
        name: 'file',
        action: `${config.apiUrl}/admin/upload/upload-image`,
        accept: '.png,.jpg,.bmp,.jpeg',
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload: async (file) => {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                message.error('请上传小于2MB的图片！')
                return false;
            }
            message.loading('图片上传中')
        },
        onChange: async (info) => {
            if (info.file.status === 'done') {
                message.success('图片上传成功！')
                let response = info.file.response;
                if (response['status']) {
                    uploaded(response['data']);
                } else {
                    if (error !== undefined) {
                        error(response['message']);
                    } else {
                        message.error(response['message']);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} 图片上传失败.`);
            }
        },
    };
}

const Option = Select.Option;
const DATE_FORMAT = 'YYYY-MM-DD';
const merchantShortNameTips = {
    ctx: '请输入商户简称',
    type: 'error'
};
const ContactorRealNameTips = {
    ctx: '请填写超级管理员姓名',
    type: 'error'
};

const ContactorIdCardNumberTips = {
    ctx: '请填写证件号码',
    type: 'error'
};

const ContactorMobilePhoneNumberTips = {
    ctx: '请填写手机号码',
    type: 'error'
};

const ContactorEmailTips = {
    ctx: '请填写邮箱地址',
    type: 'error'
};

const MarginLeft20 = {marginLeft: 20};
const Width240 = {width: 240};

const ErrorTips = (props) => {
    let {ctx, show} = props;
    return show ? (<Tips ctx={ctx}/>) : null;
}

const InputErrors = {};
const VariableKeys = {};
const InputComponentDidMount = (value, field, focus, dispatch, setSubMerchantMaterialInfo) => {
    VariableKeys[field] = true;
    if (!value && !focus && field) {
        dispatch(setSubMerchantMaterialInfo({focus: field}))
    }
    return () => {
        VariableKeys[field] = false;
        if (focus && field && focus === field) {
            let material = {};
            material['focus'] = '';
            dispatch(setSubMerchantMaterialInfo(material))
        }
    }
};
const DatePickerBox = ({value, keyField, field, tips}) => {
    const dispatch = useDispatch();
    const {focus} = useSelector(subMerchantMaterialInfoSelector);
    let f = InputErrors[field] !== undefined ? (InputErrors[field] && (value === undefined || !value)) : false;
    InputErrors[field] = f;
    const [error, setError] = useState(f);
    const InputStyle = error ? {
        border: "1px solid red",
    } : {};
    useEffect(() => {
        return InputComponentDidMount(value, field, focus, dispatch, setSubMerchantMaterialInfo);
    }, []);
    return (<>
        <DatePicker
            id={keyField}
            style={InputStyle}
            value={value ? moment(value, DATE_FORMAT) : null}
            locale={locale} onChange={(e) => {
            let material = {};
            material[keyField] = e ? e.format(DATE_FORMAT) : null;
            if (!e) {
                material['focus'] = field;
                setError(true);
                InputErrors[field] = true;
            } else {
                if (focus === field) {
                    material['focus'] = '';
                }
                setError(false);
                InputErrors[field] = false;
            }
            dispatch(setSubMerchantMaterialInfo(material))
        }}
            autoFocus={focus === field}
            onBlur={() => {
                let material = {};
                if (value) {
                    if (focus === field) {
                        material['focus'] = '';
                    }
                    setError(false);
                    InputErrors[field] = false;
                } else {
                    material['focus'] = field;
                    setError(true);
                    InputErrors[field] = true;
                }
                dispatch(setSubMerchantMaterialInfo(material))
            }}
        />
        {tips !== undefined && tips !== null ?
            <ErrorTips ctx={tips} show={error}/> : null}
    </>);
};
const InputBox = (props) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(props['value']);
    const {focus} = useSelector(subMerchantMaterialInfoSelector);
    let f = InputErrors[props.field] !== undefined ? (InputErrors[props.field] && (value === undefined || !value)) : false;
    InputErrors[props.field] = f;
    const [error, setError] = useState(f);
    const InputStyle = error ? {
        border: "1px solid red",
        ...props.style
    } : {
        ...props.style
    };
    useEffect(() => {
        return InputComponentDidMount(value, props.field, focus, dispatch, setSubMerchantMaterialInfo);
    }, []);
    return (
        <div className='inputBox flex'>
            <p className='inputTitle'>{props.title}</p>
            <Input
                key={props.inputKey}
                onBlur={async (e) => {
                    let empty = e.target['value'].length === 0;
                    InputErrors[props.field] = empty;
                    setError(InputErrors[props.field]);
                    await props.onBlur(e);
                    if (focus === props.field && !empty) {
                        dispatch(setSubMerchantMaterialInfo({focus: ''}));
                    }
                }}
                onChange={(e) => {
                    if (error) {
                        let empty = e.target['value'].length === 0;
                        if (!empty) {
                            InputErrors[props.field] = false;
                            setError(empty);
                        }
                    }
                    setValue(e.target['value'])
                }}
                value={value}
                style={InputStyle}
                placeholder={props.placeholder}
                maxLength={props.maxLength}
                readOnly={props.readonly}
                autoFocus={focus === props.field}
            />
            <p className='explain' style={MarginLeft20}>{props.example}</p>
            {props.tips !== undefined && props.tips !== null ?
                <ErrorTips ctx={props.tips} show={error}/> : null}
            <Audit name={props.field}/>
        </div>
    );
}
const MerchantShortName = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    const dispatch = useDispatch();
    const setMchShortName = async (e) => {
        dispatch(setSubMerchantMaterialInfo({merchantShortName: e.target.value}));
    };
    return (
        <>
            <p className='title'>商户基本信息</p>
            <InputBox
                title={"商户简称"}
                inputKey={"merchantShortName"}
                onBlur={setMchShortName}
                value={subMerchantMaterialInfo.merchantShortName}
                style={Width240}
                placeholder={'请输入商户简称(最多21字)'}
                maxLength={21}
                example="示例值：高新区美味团、优品店"
                field="merchant_shortname"
                tips={merchantShortNameTips}
            />
        </>
    );
};

const OwnerRealNameTips = {
    ctx: '请输入经营者/法定代表人姓名',
    type: 'error'
};
const OwnerIdCardNumberTips = {
    ctx: '请填写身份证号码',
    type: 'error'
};

const OwnerIdCardAddressTips = {
    ctx: '请输入法人身份证居住地址',
    type: 'error'
};

const OwnerIdCardAddress = (props) => {
    let {ownerIdCardAddress, organizationType} = props;
    const dispatch = useDispatch();
    const setIdCardAddress = (e) => {
        dispatch(setSubMerchantMaterialInfo({ownerIdCardAddress: e.target['value']}))
    }
    return organizationType === WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS ? (
        <InputBox
            title={'身份证居住地址:'}
            onBlur={setIdCardAddress}
            value={ownerIdCardAddress}
            style={Width240}
            placeholder={'请输入法人身份证居住地址'}
            maxLength={118}
            tips={OwnerIdCardAddressTips}
            field={"id_card_address"}
        />) : null;
};

const LicensePhotoUpload = (props) => {
    const dispatch = useDispatch();
    let {photo, photoProps, tip, field} = props;
    let f = InputErrors[props.field] !== undefined ? (InputErrors[props.field] && (photo === undefined || !photo)) : false;
    const {focus} = useSelector(subMerchantMaterialInfoSelector);
    InputErrors[props.field] = f;
    const [error, setError] = useState(f);
    const InputStyle = error ? {
        border: "1px solid red",
    } : {};
    useEffect(() => {
        return InputComponentDidMount(photo, field, focus, dispatch, setSubMerchantMaterialInfo);
    }, []);
    photoProps['onBlur'] = () => {
        if (!photo) {
            setError(true);
        }
    };
    photoProps['autoFocus'] = focus === field;
    return (
        <>
            {!photo ? (<p className='photoTips'>{tip}</p>) : null}
            <div className='uploads' style={InputStyle}>
                <Upload {...photoProps}>
                    <Button icon={<UploadOutlined/>} autoFocus={focus === field}>点击上传</Button>
                </Upload>
            </div>
            {photo ? (<img src={photo} alt=''/>) : null}
        </>
    );
};

const MerchantNameTips = {
    ctx: "请填写商户/公司名称",
    type: 'error'
};
const BusinessLicenseNumberTips = {
    ctx: "请填写注册号/统一社会信用代码",
    type: 'error'
};
const BusinessLicensePhotoTips = {
    ctx: "请上传营业执照",
    type: 'error'
};
const SubMerchantLicenseInfo = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    let {companyName, businessLicenseNumber, businessLicensePhoto, submit} = subMerchantMaterialInfo;
    const dispatch = useDispatch();
    return (
        <>
            <p className='title'>入驻商户证件信息</p>
            <InputBox
                title={"商户/公司名称:"}
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({companyName: e.target['value']}))}
                value={companyName}
                style={Width240}
                placeholder={'请填写商户/公司名称'}
                example={"示例值：腾讯科技有限公司"}
                field={"merchant_name"}
                tips={MerchantNameTips}
            />
            <div className='inputBox flex'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>
                        1.个体户：个体户的商户名称不能以“公司”结尾；
                    </p>
                    <p className='explain'>
                        2.个体户：若营业执照上商户名称为空或为“无”，请填写【个体户+经营者姓名】，如“个体户小明”。
                    </p>
                </div>
            </div>

            <InputBox
                title={"营业执照注册号:"}
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({businessLicenseNumber: e.target['value']}))}
                value={businessLicenseNumber}
                style={Width240}
                placeholder='请填写注册号/统一社会信用代码'
                example={"示例值：85340111WX2XSBTO2T"}
                field={"business_license_number"}
                tips={BusinessLicenseNumberTips}
            />

            <div className='inputBox flex uploadsId'>
                <p className='inputTitle'>营业执照：</p>
                <div className='identity flex'>
                    <div className='identityPhoto font'>
                        <LicensePhotoUpload
                            tip={'请上传营业执照'}
                            photo={businessLicensePhoto}
                            photoProps={photoUploadProps({
                                uploaded: (data) => {
                                    dispatch(setSubMerchantMaterialInfo({businessLicensePhoto: data['url']}))
                                }
                            })}
                            field="business_license_copy"
                        />
                    </div>
                    <div style={Width148}>
                        <ErrorTips ctx={BusinessLicensePhotoTips} show={submit && !businessLicensePhoto}/>
                        <Audit name='business_license_copy'/>
                    </div>
                </div>
            </div>
            <div className='inputBox flex'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>
                        1.请上传证件的彩色扫描件或彩色数码拍摄件，黑白复印件需加盖公章（公章信息需完整）
                    </p>
                    <p className='explain'>
                        2.不得添加无关水印（非微信支付商户申请用途的其它水印）
                    </p>
                    <p className='explain'>
                        3.需提供证件的正面拍摄件，完整、照片信息清晰可见。信息不清晰、扭曲、压缩变形、反光、不完整均不接受
                    </p>
                    <p className='explain'>
                        4.不接受二次裁剪、翻拍、PS的证件照片
                    </p>
                </div>
            </div>
        </>);
};

const Width148 = {width: 148};
const MarginRight20 = {marginRight: 20};
const OwnerIdCardFrontPhotoTips = {
    ctx: '请上传身份证正面',
    type: 'error'
};
const OwnerIdCardBackPhotoTips = {
    ctx: '请上传身份证反面',
    type: 'error'
};

const OwnerIdCardValidTimeTips = {
    ctx: '请选择身份证有效日期',
    type: 'error'
};


// 子商户基本信息
const SubMerchantOwnerBaseInfo = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    const dispatch = useDispatch();
    let {
        ownerRealName, ownerIdCardNumber,
        ownerIdCardAddress, organizationType,
        ownerIdCardValidTimeBegin, ownerIdCardValidTimeEnd,
        ownerIdCardFrontPhoto, ownerIdCardBackPhoto,
        ownerIdCardValidation, submit, focus,
        contactorMobilePhoneNumber, contactorEmail
    } = subMerchantMaterialInfo;
    let idCardValidation = ownerIdCardValidation;
    if (ownerIdCardValidation === null) {
        idCardValidation = ID_CARD_VALID_TIME_SHORT;
        let id = setTimeout(() => {
            dispatch(setSubMerchantMaterialInfo({ownerIdCardValidation: idCardValidation}));
            clearTimeout(id);
        }, 500);
    }
    const selectIdCardValidation = (e) => {
        idCardValidation = e.target.value;
        dispatch(setSubMerchantMaterialInfo({ownerIdCardValidation: idCardValidation}));
    };

    return (<>
        <p className='title'>经营者/法人基本信息</p>
        <InputBox
            title="姓名:"
            onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({ownerRealName: e.target['value']}))}
            value={ownerRealName}
            style={Width240}
            placeholder='请输入经营者/法定代表人姓名'
            maxLength={10}
            tips={OwnerRealNameTips}
            field="id_card_name"
        />
        {organizationType === WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT ? (
            <>
                <InputBox
                    title="手机号码:"
                    value={contactorMobilePhoneNumber}
                    onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({contactorMobilePhoneNumber: e.target['value']}))}
                    style={Width240}
                    placeholder='请填写手机号码'
                    maxLength={20}
                    field="mobile_phone"
                    tips={ContactorMobilePhoneNumberTips}
                />
                <div className='inputBox flex'>
                    <p className='inputTitle'/>
                    <div>
                        <p className='explain'>
                            用于接收微信支付的重要管理信息及日常操作验证码，超管签约时可自助修改手机号，并进行短信验证
                            <span onClick={() => {
                            }} className='themeColor'>修改手机号指引</span>
                        </p>
                    </div>
                </div>
                <InputBox
                    title="邮箱:"
                    value={contactorEmail}
                    onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({contactorEmail: e.target['value']}))}
                    style={Width240}
                    placeholder='请填写邮箱地址'
                    maxLength={20}
                    field="contact_email"
                    tips={ContactorEmailTips}
                />
                <div className='inputBox flex'>
                    <p className='inputTitle'/>
                    <div>
                        <p className='explain'>
                            用于接收微信支付的开户邮件及日常业务通知
                        </p>
                    </div>
                </div>
            </>
        ) : null}
        <InputBox
            title="身份证号:"
            onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({ownerIdCardNumber: e.target['value']}))}
            value={ownerIdCardNumber}
            style={Width240}
            placeholder='请填写身份证号码'
            maxLength={18}
            tips={OwnerIdCardNumberTips}
            field="id_card_number"
        />

        <OwnerIdCardAddress ownerIdCardAddress={ownerIdCardAddress} organizationType={organizationType}/>

        <div className='inputBox flex idCardValidation'>
            <p className='inputTitle'>身份证有效期:</p>
            <Radio.Group onChange={selectIdCardValidation} defaultValue={idCardValidation}>
                <Radio value={ID_CARD_VALID_TIME_SHORT}>非长期</Radio>
                <Radio value={ID_CARD_VALID_TIME_FOREVER}>长期</Radio>
            </Radio.Group>
        </div>

        <div className='flex ownerIdCardValidTimeBegin mgb10'>
            <p className='inputTitle'>开始时间:</p>
            <DatePickerBox
                value={ownerIdCardValidTimeBegin}
                locale={locale}
                keyField="ownerIdCardValidTimeBegin"
                field='id_card_valid_time_begin'
                tips={OwnerIdCardValidTimeTips}
            />
        </div>

        {ownerIdCardValidation !== ID_CARD_VALID_TIME_FOREVER ? (<div className='flex ownerIdCardValidTimeEnd'>
            <p className='inputTitle'>结束时间</p>
            <DatePickerBox
                value={ownerIdCardValidTimeEnd}
                locale={locale}
                keyField="ownerIdCardValidTimeEnd"
                field='id_card_valid_time'
                tips={OwnerIdCardValidTimeTips}
            />
        </div>) : null}

        <div className='inputBox flex ownerIdCardValidTimeTips'>
            <p className='inputTitle'/>
            <div>
                <p className='explain'>请确保上方期限与您 身份证背面 的有效期限一致</p>
                <p className='explain'>身份证有效期需大于60天</p>
            </div>
        </div>
        <div className='inputBox flex uploadsId idCardPhotos'>
            <p className='inputTitle'>身份证件图片:</p>
            <div className='identity flex'>
                <div className='identityPhoto font'>
                    <LicensePhotoUpload
                        photo={ownerIdCardFrontPhoto}
                        photoProps={photoUploadProps({
                            uploaded: (data) => {
                                dispatch(setSubMerchantMaterialInfo({ownerIdCardFrontPhoto: data['url']}))
                            }
                        })}
                        tip={'身份证正面照片'}
                        field="id_card_copy"
                    />
                </div>
                <div className='identityPhoto back'>
                    <LicensePhotoUpload
                        photo={ownerIdCardBackPhoto}
                        photoProps={photoUploadProps({
                            uploaded: (data) => {
                                dispatch(setSubMerchantMaterialInfo({ownerIdCardBackPhoto: data['url']}))
                            }
                        })}
                        tip={'身份证反面照片'}
                        field="id_card_copy_back"
                    />
                </div>
            </div>
        </div>
        <div className='inputBox flex'>
            <p className='inputTitle'/>
            <p className='explain'>只支持JPG、BMP、PNG格式图片，文件大小不能超过2M</p>
        </div>
        <div className='inputBox flex'>
            <p style={{...Width148, ...MarginRight20}}>
                <ErrorTips ctx={OwnerIdCardFrontPhotoTips} show={submit && !ownerIdCardFrontPhoto}/>
            </p>

            <p style={Width148}>
                <ErrorTips ctx={OwnerIdCardBackPhotoTips}
                           show={submit && !ownerIdCardBackPhoto}/>
            </p>
            <p style={Width148}>
                <Audit name='id_card_copy'/>
                <Audit name='id_card_national'/>
            </p>
        </div>
    </>);
};

// 超级管理员证件信息
const AgentSuperAminLicenseInfo = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    let {
        contactorIdCardFrontPhoto, contactorIdCardBackPhoto,
        contactorIdCardValidation, contactorIdCardValidTimeBegin,
        contactorIdCardValidTimeEnd, contactorAgentLicensePhoto,
        contactorType, submit
    } = subMerchantMaterialInfo;
    const dispatch = useDispatch();
    let idCardValidation = contactorIdCardValidation;
    if (contactorIdCardValidation === null) {
        idCardValidation = ID_CARD_VALID_TIME_SHORT;
        dispatch(setSubMerchantMaterialInfo({contactorIdCardValidation: ID_CARD_VALID_TIME_SHORT}))
    }
    const selectIdCardValidation = (e) => {
        idCardValidation = e.target.value;
        dispatch(setSubMerchantMaterialInfo({contactorIdCardValidation: idCardValidation}));
    };
    return contactorType === ContactorTypeDict.TRUSTIER ? (
        <>
            <div className='inputBox flex uploadsId'>
                <p className='inputTitle'>超管身份证件图片:</p>
                <div className='identity flex'>
                    <div className='identityPhoto font'>
                        <LicensePhotoUpload
                            photo={contactorIdCardFrontPhoto}
                            photoProps={photoUploadProps({
                                uploaded: (data) => {
                                    dispatch(setSubMerchantMaterialInfo({contactorIdCardFrontPhoto: data['url']}))
                                }
                            })}
                            tip={'身份证正面照'}
                            field="contact_id_doc_copy"
                        />
                    </div>
                    <div className='identityPhoto back'>
                        <LicensePhotoUpload
                            photo={contactorIdCardBackPhoto}
                            photoProps={photoUploadProps({
                                uploaded: (data) => {
                                    dispatch(setSubMerchantMaterialInfo({contactorIdCardBackPhoto: data['url']}))
                                }
                            })}
                            tip={'身份证反面照'}
                            field="contact_id_doc_copy_back"
                        />
                    </div>
                </div>
            </div>
            <div className='inputBox flex'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>只支持JPG、BMP、PNG格式图片，文件大小不能超过2M</p>
                </div>
            </div>
            <div className='inputBox flex'>
                <p style={{...Width148, ...MarginRight20}}>
                    <ErrorTips ctx={OwnerIdCardFrontPhotoTips} show={submit && !contactorIdCardFrontPhoto}/>
                </p>

                <p style={Width148}>
                    <ErrorTips ctx={OwnerIdCardBackPhotoTips}
                               show={submit && !contactorIdCardBackPhoto}/>
                </p>
                <p style={Width148}>
                    <Audit name='contact_id_doc_copy'/>
                    <Audit name='contact_id_doc_copy_back'/>
                </p>
            </div>
            <div className='inputBox flex contactorIdCardValidation'>
                <p className='inputTitle'>身份证有效期:</p>
                <Radio.Group onChange={selectIdCardValidation} value={contactorIdCardValidation}>
                    <Radio value={ID_CARD_VALID_TIME_SHORT}>非长期</Radio>
                    <Radio value={ID_CARD_VALID_TIME_FOREVER}>长期</Radio>
                </Radio.Group>
            </div>
            <div className='flex mgb10 contactorIdCardValidTimeBegin'>
                <p className='inputTitle'>开始时间:</p>
                <DatePicker
                    defaultValue={contactorIdCardValidTimeBegin ? moment(contactorIdCardValidTimeBegin, DATE_FORMAT) : null}
                    locale={locale} onChange={(e) => {
                    dispatch(setSubMerchantMaterialInfo({contactorIdCardValidTimeBegin: e.format(DATE_FORMAT)}))
                }}/>
            </div>

            <div className='flex contactorIdCardValidTimeEnd'
                 hidden={contactorIdCardValidation !== ID_CARD_VALID_TIME_FOREVER ? '' : 'show'}>
                <p className='inputTitle'>结束时间:</p>
                <DatePicker
                    defaultValue={contactorIdCardValidTimeEnd ? moment(contactorIdCardValidTimeEnd, DATE_FORMAT) : null}
                    locale={locale}
                    onChange={(e) => dispatch(setSubMerchantMaterialInfo({contactorIdCardValidTimeEnd: e.format(DATE_FORMAT)}))}/>
            </div>

            <div className='inputBox flex contactorIdCardValidTimeTips'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>请确保上方期限与您 身份证背面 的有效期限一致</p>
                    <p className='explain'>身份证有效期需大于60天</p>
                </div>
            </div>

            <div className='inputBox flex uploadsId contactorAgentLicensePhoto'>
                <p className='inputTitle'>业务办理授权函：</p>
                <div className='identity flex'>
                    <div className='identityPhoto font'>
                        <LicensePhotoUpload
                            photo={contactorAgentLicensePhoto}
                            photoProps={photoUploadProps({
                                uploaded: (data) => {
                                    dispatch(setSubMerchantMaterialInfo({contactorAgentLicensePhoto: data['url']}))
                                }
                            })}
                            tip={'授权函'}
                        />
                    </div>
                    <p style={Width148}>
                        {/*<Tips ctx={}/>*/}
                    </p>
                </div>
            </div>
            <div className='inputBox flex'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain themeColor pointer'
                       onClick={() => {
                       }}>
                        查看示例
                    </p>
                </div>
            </div>
        </>
    ) : null;
};


// 超级管理员信息
const SubMerchantSuperAdmin = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    let {
        contactorType, contactorRealName,
        contactorIdCardNumber, contactorMobilePhoneNumber,
        contactorEmail
    } = subMerchantMaterialInfo;
    const dispatch = useDispatch();
    return (
        <>
            <p className='title'>超级管理员</p>
            <div className='inputBox flex'>
                <p className='inputTitle'>管理员类型:</p>
                <Radio.Group onChange={(e) => dispatch(setSubMerchantMaterialInfo({contactorType: e.target.value}))}
                             value={contactorType}>
                    <Radio value={ContactorTypeDict.CORPORATION}>经营者/法人</Radio>
                    <Radio value={ContactorTypeDict.TRUSTIER}>经办人</Radio>
                </Radio.Group>
                <p className="warn">超级管理员必须是进件商户的创建人！</p>
            </div>
            <InputBox
                title="超管姓名:"
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({contactorRealName: e.target['value']}))}
                value={contactorRealName}
                style={Width240}
                placeholder='请填写超级管理员姓名'
                maxLength={20}
                field="contact_name"
                tips={ContactorRealNameTips}
                // readonly={contactorType === ContactorTypeDict.CORPORATION}
            />
            <InputBox
                title="超管证件号码:"
                value={contactorIdCardNumber}
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({contactorIdCardNumber: e.target['value']}))}
                style={Width240}
                placeholder='请填写证件号码'
                maxLength={20}
                field="contact_id_card_number"
                tips={ContactorIdCardNumberTips}
                // readonly={contactorType === ContactorTypeDict.CORPORATION}
            />
            <AgentSuperAminLicenseInfo/>
            <InputBox
                title="超管手机号码:"
                value={contactorMobilePhoneNumber}
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({contactorMobilePhoneNumber: e.target['value']}))}
                style={Width240}
                placeholder='请填写手机号码'
                maxLength={20}
                field="mobile_phone"
                tips={ContactorMobilePhoneNumberTips}
            />
            <div className='inputBox flex'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>
                        用于接收微信支付的重要管理信息及日常操作验证码，超管签约时可自助修改手机号，并进行短信验证
                        <span onClick={() => {
                        }} className='themeColor'>超管修改手机号指引</span>
                    </p>
                </div>
            </div>
            <InputBox
                title="超管邮箱:"
                value={contactorEmail}
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({contactorEmail: e.target['value']}))}
                style={Width240}
                placeholder='请填写邮箱地址'
                maxLength={20}
                field="contact_email"
                tips={ContactorEmailTips}
            />
            <div className='inputBox flex'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>
                        用于接收微信支付的开户邮件及日常业务通知
                    </p>
                </div>
            </div>
        </>
    );
};

/**
 * 受益人组建定义
 * **/
// 添加受益人
const AddBenefitPersonButton = (props) => {
    let {benefitIsSelf} = props;
    const dispatch = useDispatch();
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    const addBenefitPerson = () => {
        const person = {
            ubo_id_doc_name: '',
            ubo_id_doc_number: '',
            ubo_id_doc_address: '',
            id_doc_validation: ID_CARD_VALID_TIME_SHORT,
            ubo_id_doc_copy: '',
            ubo_id_doc_copy_back: ''
        };
        let list = [...subMerchantMaterialInfo.benefitPersonList];
        list.push(person);
        dispatch(setSubMerchantMaterialInfo({benefitPersonList: list}));
    }
    return !benefitIsSelf ? (
        <Button onClick={addBenefitPerson} size='small' className='themeBtn mgl50'>添加受益人</Button>) : null;
};
const BenefitPersonItem = (props) => {
    let {benefitPerson, index, removePerson, updateBenefitPerson} = props;
    let [person, setPerson] = useState(benefitPerson);

    return (
        <div className="benefitPersonItem">
            <div className='inputBox flex'>
                <p className='inputTitle'>{index + 1}号受益人姓名：</p>
                <Input value={person['ubo_id_doc_name']} onBlur={() => {
                    updateBenefitPerson(index, person);
                }} onInput={async (e) => {
                    setPerson({...person, ubo_id_doc_name: e.target['value']})
                }} style={Width240} placeholder='请填写受益人姓名' maxLength={20}/>
            </div>

            <div className='inputBox flex'>
                <p className='inputTitle'>身份证号码：</p>
                <Input value={person['ubo_id_doc_number']} onInput={async (e) => {
                    setPerson({...person, ubo_id_doc_number: e.target['value']})
                }} style={Width240} placeholder='请填写身份证号码' maxLength={20}/>
            </div>

            <div className='inputBox flex'>
                <p className='inputTitle'>身份证地址：</p>
                <Input value={person['ubo_id_doc_address']} onInput={async (e) => {
                    setPerson({...person, ubo_id_doc_address: e.target['value']})
                }} style={Width240} placeholder='请填写身份证地址' maxLength={20}/>
            </div>

            <div className='inputBox flex'>
                <p className='inputTitle'>身份证有效期：</p>
                <DatePicker className='mgr10' onChange={(data, formatDate) => {
                    setPerson({...person, ubo_id_doc_valid_time_begin: formatDate})
                }} placeholder='开始日期'/>

                {
                    person['id_doc_validation'] === ID_CARD_VALID_TIME_FOREVER ? null : (
                        <DatePicker className='mgr10' onChange={(data, formatDate) => {
                            setPerson({...person, ubo_id_doc_valid_time_end: formatDate})
                        }} placeholder='结束日期'/>
                    )
                }
                <Checkbox onChange={(data) => {
                    setPerson({
                        ...person,
                        id_doc_validation: data.target.checked ? ID_CARD_VALID_TIME_FOREVER : ID_CARD_VALID_TIME_SHORT
                    })
                }}>长期</Checkbox>
            </div>

            <div className='inputBox flex uploadsId benefitPersonIdCardPhotos'>
                <p className='inputTitle'>身份证件图片:</p>
                <div className='identity flex'>
                    <div className='identityPhoto font'>
                        <LicensePhotoUpload
                            photo={person['ubo_id_doc_copy']}
                            photoProps={photoUploadProps({
                                uploaded: (data) => {
                                    setPerson({
                                        ...person,
                                        ubo_id_doc_copy: data['url']
                                    })
                                }
                            })}
                            tip={'身份证正面照'}/>
                    </div>
                    <div className='identityPhoto back'>
                        <LicensePhotoUpload
                            photo={person['ubo_id_doc_copy_back']}
                            photoProps={photoUploadProps({
                                uploaded: (data) => {
                                    setPerson({
                                        ...person,
                                        ubo_id_doc_copy_back: data['url']
                                    })
                                }
                            })}
                            tip={'身份证反面照'}/>
                    </div>
                </div>
            </div>
            <Button danger className='mgb20 deleteButton' onClick={() => {
                let id = setTimeout(() => {
                    removePerson(index);
                    clearTimeout(id);
                }, 300)
            }}>删除</Button>
        </div>
    );
};
const BenefitPersonComponent = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    let {benefitIsSelf, benefitPersonList} = subMerchantMaterialInfo;
    const dispatch = useDispatch();
    const removePerson = (index) => {
        let list = [...benefitPersonList];
        list.splice(index, 1);
        dispatch(setSubMerchantMaterialInfo({benefitPersonList: list}));
    };
    const updateBenefitPerson = (index, person) => {
        let list = [...benefitPersonList];
        list[index] = person;
        dispatch(setSubMerchantMaterialInfo({benefitPersonList: list}));
    };
    return (
        <>
            <p className='title'>受益人</p>
            <div className='inputBox flex'>
                <p className='inputTitle'>经营者/法人是否为受益人:</p>
                <Radio.Group onChange={(e) => dispatch(setSubMerchantMaterialInfo({benefitIsSelf: e.target.value}))}
                             value={benefitIsSelf}>
                    <Radio value={true}>是</Radio>
                    <Radio value={false}>否</Radio>
                </Radio.Group>
                <AddBenefitPersonButton benefitIsSelf={benefitIsSelf}/>
            </div>
            <div className="flex inputBox benefitPersonList">
                {
                    benefitPersonList.map((item, index) => {
                        return (<BenefitPersonItem benefitPerson={item} index={index} removePerson={removePerson}
                                                   updateBenefitPerson={updateBenefitPerson}/>);
                    })
                }
            </div>

        </>
    );
};

const Width120 = {width: 120};
const Width600 = {width: 600};
const Margin5_0 = {margin: '5px 0'};
const OpenAccountNameTips = {
    ctx: '请填写开户名称',
    type: 'error'
};
const OpenAccountBankTips = {ctx: '请输入开户银行', type: 'error'};
const BankAccountNumberTips = {ctx: '请输入开户银行', type: 'error'};
const BankList = qs.allBankList();
const BindBankInfoComponent = () => {
    const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    const dispatch = useDispatch();
    let {
        bindBankAccountType,
        openAccountName,
        openAccountBank,
        bankAccountNumber,
        bankAddressCodes,
        organizationType,
    } = subMerchantMaterialInfo;
    const FieldName = {label: 'name', value: 'code'};
    const DefaultAddress = bankAddressCodes ? bankAddressCodes : (['110000', '110100', '110101']);
    const selectBank = (e) => {
        let bankName = '';
        BankList.forEach(bankAccount => {
            if (e.target.value === bankAccount.id && e.target.value !== OTHER_BANK_ID) {
                bankName = bankAccount.name;
            }
        });
        dispatch(setSubMerchantMaterialInfo({openAccountBank: bankName}));
    }
    let options = [{
        label: '对公账户',
        value: TO_COMPANY_ACCOUNT
    }, {
        label: '对私账户',
        value: TO_PERSONAL_ACCOUNT
    }];
    let bankAccountTypeSelected = (bindBankAccountType) => {
        if (organizationType === WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT) {
            if (bindBankAccountType !== options[1]['value']) {
                dispatch(setSubMerchantMaterialInfo({bindBankAccountType: TO_PERSONAL_ACCOUNT}));
            }
            return options[1];
        }else if (organizationType === WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS) {
            if (bindBankAccountType !== options[0]['value']) {
                dispatch(setSubMerchantMaterialInfo({bindBankAccountType: TO_COMPANY_ACCOUNT}));
            }
            return options[0];
        }
        for (let i = 0; i < options.length; i++) {
            if (options[i]['value'] === bindBankAccountType) {
                return options[i];
            }
        }
        return null;
    }
    return (
        <>
            <p className='title'>结算账户信息</p>
            <div className='inputBox flex'>
                <p className='inputTitle'>账户类型:</p>
                <Select defaultValue={bankAccountTypeSelected(bindBankAccountType)}
                        labelInValue={true}
                        disabled={organizationType === WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS || organizationType === WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT} placeholder='可选择'
                        style={Width120} onChange={(e) => {
                    dispatch(setSubMerchantMaterialInfo({bindBankAccountType: e.target.value}))
                }}>
                    <Option value={TO_COMPANY_ACCOUNT} style={Width120}>对公账户</Option>
                    <Option value={TO_PERSONAL_ACCOUNT} style={Width120}>对私账户</Option>
                </Select>
                <Audit name='bank_account_type'/>
            </div>
            <div className='inputBox flex'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>
                        主体为企业，账户类型只能选择对公账户
                    </p>
                </div>
            </div>
            <InputBox
                title="开户名称:"
                value={openAccountName}
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({openAccountName: e.target['value']}))}
                style={Width240} placeholder='请填写开户名称' maxLength={20}
                tips={OpenAccountNameTips}
                field="account_name"
            />

            <div className='inputBox flex openAccountNameTips'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>
                        1、选择经营者个人银行卡时，开户名称必须与身份证姓名一致。
                    </p>
                    <p className='explain'>
                        2、选择对公账户时，开户名称必须与营业执照上的“商户名称”一致。
                    </p>
                </div>
            </div>
            <InputBox
                title="开户银行:"
                value={openAccountBank}
                disabled={true}
                onBlur={e => dispatch(setSubMerchantMaterialInfo({openAccountBank: e.target['value']}))}
                style={Width240}
                placeholder='请选择下方开户银行'
                maxLength={20}
                tips={OpenAccountBankTips}
                example="示例值：工商银行"
                field="account_bank"
                readonly={selectedBankId(openAccountBank) !== OTHER_BANK_ID ? true : false}
            />
            <div className='inputBox flex openAccountBankSelector'>
                <p className='inputTitle'/>
                <div>
                    <p className='explain'>
                        支持银行(点击可选择)
                    </p>
                    <div className='explain' style={{...Width600, Margin5_0}}>
                        <Radio.Group onChange={selectBank} value={selectedBankId(openAccountBank)}>
                            {
                                BankList.map(({id, name}) => {
                                    return (<Radio value={id} key={id}>{name}</Radio>);
                                })
                            }
                        </Radio.Group>
                    </div>
                    <p className='warn'>如为其他银行,需填写银行全称，如"深圳农村商业银行XXX支行"! </p>
                </div>
            </div>

            <div className='inputBox flex bankAddress'>
                <p className='inputTitle'>开户地:</p>
                <Cascader
                    value={DefaultAddress}
                    fieldNames={FieldName}//自定义字段名
                    options={Regions}
                    onChange={async (e) => {
                        dispatch(setSubMerchantMaterialInfo({bankAddressCodes: e}));
                    }}
                    displayRender={(e) => {//选择后展示的渲染函数
                        return e.join('/');
                    }}
                    showSearch={(val, result) => {
                    }}
                    placeholder="请选择开户地"
                />
                <Audit name='bank_address_code'/>
            </div>
            <InputBox
                title="银行账号:"
                value={bankAccountNumber}
                onBlur={async (e) => dispatch(setSubMerchantMaterialInfo({bankAccountNumber: e.target['value']}))}
                style={Width240} placeholder='请填写银行账号'
                maxLength={30}
                field="account_number"
                tips={BankAccountNumberTips}
            />
        </>
    );
};


const MicroSubMerchantMaterials = () => {
    return (<div className='material'>
        <div className='title subMchMaterial'>小微商户进件</div>
        <div className='beginStep'>
            <MerchantShortName/>
            <SubMerchantOwnerBaseInfo/>
            <BindBankInfoComponent/>
        </div>
    </div>);
};

const SelfEmploymentMerchantMaterials = () => {
        return (<div className='material'>
            <div className='title subMchMaterial'>个体商户进件</div>
            <div className='beginStep'>
                <MerchantShortName/>
                <SubMerchantOwnerBaseInfo/>
                <SubMerchantLicenseInfo/>
                <SubMerchantSuperAdmin/>
                {/*<BenefitPersonComponent/>*/}
                <BindBankInfoComponent/>
            </div>
        </div>);
    }
;

const EnterpriseBusinessMerchantMaterials = () => {
        return (<div className='material'>
            <div className='title subMchMaterial'>企业商户进件</div>
            <div className='beginStep'>
                <MerchantShortName/>
                <SubMerchantOwnerBaseInfo/>
                <SubMerchantLicenseInfo/>
                <SubMerchantSuperAdmin/>
                {/*<BenefitPersonComponent/>*/}
                <BindBankInfoComponent/>
            </div>
        </div>);
    }
;


const SubMerchantMaterials = () => {
        const subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
        let organizationType = subMerchantMaterialInfo.organizationType;
        const dispatch = useDispatch();
        let oldFocus = '';
        const nextStepAction = async (step, nextStep) => {
            // 判断材料
            let focus = '';
            for (let k in InputErrors) {
                if (InputErrors[k] === true) {
                    focus = k;
                    break;
                }
            }
            if (focus) {
                dispatch(setSubMerchantMaterialInfo({focus: false}));
                dispatch(setSubMerchantMaterialInfo({submit: true, focus: focus}));
                oldFocus = focus;
            }
            let error = false;
            if (!focus) {
                for (const k in KeysMap) {
                    if (VariableKeys[KeysMap[k]] === true) {
                        if (!subMerchantMaterialInfo[k]) {
                            error = true;
                            InputErrors[KeysMap[k]] = true;
                            oldFocus = KeysMap[k];
                        } else {
                            InputErrors[KeysMap[k]] = false;
                        }
                    }
                }
                dispatch(setSubMerchantMaterialInfo({submit: true, focus: oldFocus}));
            }
            if (error || focus) {
                return false;
            }
            return await EventDispatcher.dispatch(new SubmitSubMchMaterialEvent({...subMerchantMaterialInfo}));
        };

        const Material = () => {
            switch (organizationType) {
                case WeChatOrganizationTypeDict.ENTERPRISE_BUSINESS:
                    return (<EnterpriseBusinessMerchantMaterials/>);
                case WeChatOrganizationTypeDict.SELF_EMPLOYMENT_MERCHANT:
                    return (<SelfEmploymentMerchantMaterials/>);
                case WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT:
                    return (<MicroSubMerchantMaterials/>)
                default:
                    return null;
            }
        };

        return (<>
            <Material/>
            <StepController preStepButtonName={'上一步'} nexStepButtonName={'提交材料'} nextStepAction={nextStepAction}/>
        </>);
    }
;
export default SubMerchantMaterials;